import dissocDeep from '@/helpers/misc/dissocDeep';

const clearTypeNameFromObject = object => dissocDeep('__typename', object);

export default clearTypeNameFromObject;
